<div class="mb-4">
  <div class="card mb-4" [formGroup]="organizationForm">
    <h3 class="green decoration mb-4">
      <span *ngIf="!id">Registrar nuevo acuerdo comercial</span>
      <span *ngIf="id">Editar acuerdo comercial</span>
    </h3>

    <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('organization_id').dirty && organizationForm.get('organization_id').invalid">
      <span>Seleccionar Cliente / Comercio*</span>
      <mat-select (click)="setFocus('matInput1')" formControlName="organization_id" placeholder="Seleccione una opción" (selectionChange)="getDataOrganization()">
        <ng-container *ngIf="organizations; else elseOrganizations">
          <div class="filter_option">
            <input placeholder="Buscar..." [(ngModel)]="filterTerm" class="!outline-none" [ngModelOptions]="{standalone: true}" id="matInput1">
          </div>
          <mat-option value="">Seleccione una opción</mat-option>
          <mat-option *ngFor="let organization of organizations | filter: filterTerm; let i = index" [value]="organization.id">{{ organization.name }}</mat-option>
        </ng-container>
        <ng-template #elseOrganizations>
          <mat-option value="">No se encontraron resultados...</mat-option>
        </ng-template>
      </mat-select>
      <!-- <select formControlName="organization_id" (change)="getDataOrganization()">
        <option value="">Seleccione una opción</option>
        <option *ngFor="let organization of organizations" [value]="organization.id">{{ organization.name }}</option>
      </select> -->
      <p *ngIf="organizationForm.get('organization_id').dirty && organizationForm.get('organization_id').invalid">
        <img src="../../../assets/img/x-circle.svg" alt="icon">
        <label *ngIf="organizationForm.get('organization_id').errors.required">Este campo es necesario</label>
      </p>
    </div>
    <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('charge_frequency').dirty && organizationForm.get('charge_frequency').invalid">
      <span>Frecuencia de cobro*</span>
      <mat-select (click)="setFocus('matInput2')" formControlName="charge_frequency" placeholder="Seleccione una opción">
        <ng-container *ngIf="charges; else elseCharges">
          <div class="filter_option">
            <input placeholder="Buscar..." [(ngModel)]="filterTerm2" class="!outline-none" [ngModelOptions]="{standalone: true}" id="matInput2">
          </div>
          <mat-option value="">Seleccione una opción</mat-option>
          <mat-option *ngFor="let charge of charges | filter: filterTerm2; let i = index" [value]="charge.value">{{ charge.name }}</mat-option>
        </ng-container>
        <ng-template #elseCharges>
          <mat-option value="">No se encontraron resultados...</mat-option>
        </ng-template>
      </mat-select>
      <p *ngIf="organizationForm.get('charge_frequency').dirty && organizationForm.get('charge_frequency').invalid">
        <img src="../../../assets/img/x-circle.svg" alt="icon">
        <label *ngIf="organizationForm.get('charge_frequency').errors.required">Este campo es necesario</label>
      </p>
    </div>
    <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('status').dirty && organizationForm.get('status').invalid">
      <span>Estado*</span>
      <mat-select (click)="setFocus('matInput3')" formControlName="status" placeholder="Seleccione una opción">
        <ng-container *ngIf="statuses; else elseStatuses">
          <div class="filter_option">
            <input placeholder="Buscar..." [(ngModel)]="filterTerm3" class="!outline-none" [ngModelOptions]="{standalone: true}" id="matInput3">
          </div>
          <mat-option value="">Seleccione una opción</mat-option>
          <mat-option *ngFor="let status of statuses | filter: filterTerm2; let i = index" [value]="status.value">{{ status.name }}</mat-option>
        </ng-container>
        <ng-template #elseStatuses>
          <mat-option value="">No se encontraron resultados...</mat-option>
        </ng-template>
      </mat-select>
      <p *ngIf="organizationForm.get('status').dirty && organizationForm.get('status').invalid">
        <img src="../../../assets/img/x-circle.svg" alt="icon">
        <label *ngIf="organizationForm.get('status').errors.required">Este campo es necesario</label>
      </p>
    </div>
    <!-- <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('trial_end').dirty && organizationForm.get('trial_end').invalid">
      <span>Periodo de prueba</span>
      <input type="date" formControlName="trial_end">
      <p *ngIf="organizationForm.get('trial_end').dirty && organizationForm.get('trial_end').invalid">
        <img src="../../../assets/img/x-circle.svg" alt="icon">
        <label *ngIf="organizationForm.get('trial_end').errors.required">Este campo es necesario</label>
      </p>
    </div> -->
    <!-- <div class="row">
      <div class="col-lg-12">
        <div class="form-wrapper mb-3">
          <span>Correo Electrónico</span>
          <input type="mail" formControlName="organization_email" [attr.disabled]="true">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-wrapper mb-3">
          <span>Etiqueta de negocio</span>
          <input type="text" formControlName="organization_label" [attr.disabled]="true">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-wrapper mb-3">
          <span>Teléfono del negocio</span>
          <input type="string" formControlName="organization_phone" [attr.disabled]="true">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-wrapper mb-3">
          <span>Cliente</span>
          <input type="text" formControlName="organization_name_contact" [attr.disabled]="true">
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-wrapper mb-3">
          <span>Ciudad</span>
          <input type="text" formControlName="organization_city" [attr.disabled]="true">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-wrapper">
          <span>Zona</span>
          <input type="text" formControlName="organization_zone" [attr.disabled]="true">
        </div>
      </div>
    </div> -->
  </div>
  <div class="card">
    <h3 class="green decoration mb-4">Productos / Servicios añadidos</h3>
    <app-custom-table-min [displayedColumns]="displayedColumns" [data]="dataSource" [customH]="'custom-1'" (eventUpdateData)="getData()" (eventSendActualData)="updateData($event)"></app-custom-table-min>
    <button class="btn btn-primary big mt-4" (click)="addtradeAgreement()">Añadir producto</button>

    <!-- <h3 class="green decoration mb-4">Precio Total</h3>
    <div class="flex gap-4 justify-end">
      <div class="form-wrapper mb-3 max-w-[80px]">
        <input type="text" class="text-center" placeholder="--" value="Bs" disabled>
      </div>
      <div class="form-wrapper mb-3 max-w-[180px]">
        <input type="number" class="text-center big" placeholder="--" value="400" disabled>
      </div>
    </div> -->
  </div>
</div>
<div class="table-title end">
  <div class="title-form-wrapper">
    <a routerLink="/dashboard/trade-agreements" class="btn btn-outline-accent big">Cancelar</a>
    <button class="btn btn-primary big" (click)="sendApporval()" *ngIf="!id">
      <i class="fas fa-plus"></i> Guardar
    </button>
    <button class="btn btn-primary big" (click)="editApporval()" *ngIf="id">Guardar</button>
  </div>
</div>
